
import { mapState } from 'vuex'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'

export default {
directives: {
TransferDom
},
props: {},
inject: ['reload'],
data() {
return {
formData:{
email:'',
act:'login'
},
status:1
}
},
created() {

},
mounted() {

},
watch:{
isGuest(val, oldVal){
this.status = 1
},
},
computed: {
...mapState(['isGuest']),
},
methods: {
submitConfirm() {
let that = this
this.$validator.validateAll().then(function(success) {
if (!success) return;
that._ajax.post_form('/member/register_guest', that.formData, that).then(res => {
if (res !== false) {
for (var i in res) {
that.token_conf.set(i,res[i])
}
that.$store.commit('G_GUESTBOOKING', false)
that.reload()
}
})
})
},
onClose(){
this.$store.commit('G_GUESTBOOKING', false)
},
resetForm(field) {
this.formData[field] = ''
},
onRedirect(url){
this.$router.push(url)
this.$store.commit('G_GUESTBOOKING', false)
},
onGuest(){
let that = this
that._ajax.post_form('/member/register_guest', {act:'login'}, that,1,1,1).then(res => {
if (res !== false) {
for (var i in res) {
that.token_conf.set(i,res[i])
}
that.$store.commit('G_GUESTBOOKING', false)
setTimeout(function(){
that.reload()
}, 1000);
}
})

}
}
}

